<template>
  <div>
    <div class="header"></div>
    <div class="news">
      <!-- tab栏 -->
      <div class="tab">
        <ul>
          <li
            v-for="(item, index) in arrowList"
            :key="index"
            :class="{active: tabIndex == index}"
            @click="activeclick(index)"
          >{{item}}</li>
        </ul>
        <div class="crumbs">
          <img src="../../../../static/wy/icon_shouye.png" alt />
          <span @click="$router.push('/home')">首页</span>
          <img src="../../../../static/wy/icon_jiantou.png" alt />
          <span>{{arrow}}</span>
        </div>
      </div>
      <!-- 联系我们 -->
      <div class="contact" v-show="tabIndex == 0">
        <div class="info">
          <div class="text3" style="height:23px">
            <div style="margin-right:8px">
              <span>单位名称:</span>
            </div>
            <span>深圳市司法鉴定协会</span>
          </div>
          <div class="text">
            <span>联系电话:</span>
            <span>0755-82019586、82019601</span>
          </div>
          <!-- <div class="text2">
            <span style="margin-right:2em">传</span>
            <span>真:</span>
            <span>0755-XXXXXXXXXX</span>
          </div> -->
          <!-- <div class="text2">
            <span style="margin-right:2em">邮</span>
            <span>箱:</span>
            <span>XXXXXXX@163.com</span>
          </div> -->
          <!-- <div class="text2">
            <span style="margin-right:2em">邮</span>
            <span>编:</span>
            <span>XXXXXXX@</span>
          </div> -->
          <div class="text3">
            <div style="margin-right:8px">
              <span style="margin-right:2em">地</span>
              <span>址:</span>
            </div>
            <span>深圳市福田区莲花街道益田路江苏大厦A2402-A</span>
          </div>
        </div>
        <div id="map">
          <img src="../../../assets/htImg/map.jpg" alt />
        </div>
      </div>
      <!-- 投诉建议 -->
      <div class="suggest" v-show="tabIndex == 1">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          style="width:90%"
        >
          <el-form-item label="联系方式" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="手机号码" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="反馈内容" prop="desc">
            <el-input
              type="textarea"
              v-model="ruleForm.desc"
              maxlength="200"
              show-word-limit
              placeholder="请填写内容"
              resize="none"
              :rows="8"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="btn" type="danger" @click="submit('ruleForm')">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { contactsData } from "../../../api/officialWebsite";
export default {
  data() {
    return {
      arrow: "联系我们",
      arrowList: ["联系我们", "投诉建议"],
      tabIndex: 0,
      ruleForm: {
        phone: "",
        desc: "",
      },
      rules: {
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            min: 3,
            max: 11,
            message: "长度在 3 到 11 个字符",
            trigger: "blur",
          },
        ],
        desc: [{ required: true, message: "请填写反馈内容", trigger: "blur" }],
      },
    };
  },
  mounted() {
    // this.mapChange();
  },
  // updated() {
  //   this.mapChange();
  // },
  watch: {
    "ruleForm.phone": {
      deep: true,
      handler: function (value) {
        if (value) {
          this.ruleForm.phone = value.replace(/\D/g, "");
        }
      },
    },
  },
  methods: {
    /* mapChange(){
      var map = new window.BMap.Map("map");          // 创建地图实例  
      var point = new window.BMap.Point(114.051631,22.557679);  // 创建点坐标  
      map.enableScrollWheelZoom(true);  
      var marker = new window.BMap.Marker(point);        // 创建标注    
      map.addOverlay(marker); 
      map.centerAndZoom(point, 15);
      // 创建信息窗口
      var opts = {
        width: 200,
        height: 100,
        title: '深圳市司法鉴定协会'
      };
      var infoWindow = new window.BMap.InfoWindow('地址：广东省深圳市福田区景田路72号天平大厦10楼1015室', opts);
      // 点标记添加点击事件
      marker.addEventListener('click', function () {
        map.openInfoWindow(infoWindow, point); // 开启信息窗口
      });
    }, */
    activeclick(index) {
      this.tabIndex = index;
      switch (this.tabIndex) {
        case 0:
          this.arrow = "联系我们";
          break;
        case 1:
          this.arrow = "投诉建议";
          break;
        default:
          break;
      }
    },
    submit(ruleForm) {
      if (!this.ruleForm.phone) {
        this.$message({
          message: "手机号码不能为空",
          type: "warning",
        });
        return;
      } else {
        if (!/^1[34578]\d{9}$/.test(this.ruleForm.phone)) {
          this.$message.error("手机号码格式不对!");
          return;
        }
      }
      if (!this.ruleForm.desc) {
        this.$message.error("反馈内容不能为空!");
        return
      }
      contactsData({
        Contact: this.ruleForm.phone,
        Content: this.ruleForm.desc,
      }).then((res) => {
        if (res.result == 1) {
          this.$message({
            message: "恭喜你，提交成功",
            type: "success",
          });
        }else {
          this.$message.error("提交失败");
        }
      });
      this.$refs[ruleForm].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .BMap_cpyCtrl {
  display: none;
}
/deep/ .anchorBL {
  display: none;
}
.btn {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  position: absolute;
  bottom: -193px;
  left: 200px;
  background-color: #b82925;
}
.header {
  width: 1920px;
  height: 400px;
  background: url("../../../../static/wy/banner4.png") no-repeat center center;
  background-size: 100% 100%;
}
.news {
  width: 70%;
  height: 652px;
  background: url("../../../../static/wy/bj.png") no-repeat;
  // background-size: 100% 100%;
  margin: 0 auto;
  margin-top: -90px;
  overflow: hidden;
  margin-bottom: 120px;
  // 导航栏
  .tab {
    width: 85%;
    height: 46px;
    // background-color: burlywood;
    margin: 0 auto;
    margin-top: 70px;
    margin-bottom: 60px;
    display: flex;
    justify-content: space-between;
    ul {
      height: 100%;
      display: flex;
      justify-content: space-between;
      li {
        display: inline-block;
        width: 120px;
        height: 46px;
        font-size: 18px;
        font-weight: 600;
        line-height: 46px;
        text-align: center;
        cursor: pointer;
      }
      .active {
        background-color: #f2f2f2;
        color: red;
        border-bottom: 2px solid red;
        position: relative;
        font-size: 20px;
      }
      .active::after {
        content: "";
        position: absolute;
        left: 46%;
        bottom: -6px;
        border-width: 0 6px 6px;
        border-style: solid;
        border-color: transparent transparent red;
        transform: rotate(180deg);
      }
    }
    .crumbs {
      height: 100%;
      display: flex;
      align-items: center;
      img {
        margin-right: 5px;
      }
      img:nth-child(1) {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
      img:nth-child(2) {
        width: 8px;
        height: 16px;
      }
      span {
        display: inline-block;
        margin-right: 6px;
        color: #9a9a9a;
        font-size: 16px;
        font-weight: 400;
        cursor: pointer;
      }
    }
  }
  // 联系我们
  .contact {
    width: 85%;
    height: 360px;
    // background-color: aqua;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .info {
      width: 362px;
      height: 100%;
      display: flex;
      flex-direction: column;
      h2 {
        margin-top: 20px;
        margin-bottom: 30px;
      }
      .text,
      .text2,
      .text3 {
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        margin-top: 14px;
      }
      .text {
        span:nth-child(1) {
          margin-right: 8px;
        }
      }
      .text2 {
        span:nth-child(2) {
          margin-right: 8px;
        }
      }
      .text3 {
        display: flex;
        div {
          height: 43px;
          display: flex;
        }
      }
    }
    #map {
      width: 670px;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  // 投诉建议
  .suggest {
    width: 695px;
    height: 487px;
    margin: 0 auto;
    background-color: aquamarine;
    background: url("../../../../static/wy/pic_xinfeng.png") no-repeat;
    position: relative;
  }
}
</style>
